import { __ } from '@wordpress/i18n';
import { useEffect, useState } from '@wordpress/element';
import apiFetch from '@wordpress/api-fetch';
import CardList from './CardList';
import CardListLoader from './CardListLoader';
import { RegisteredCard } from '../../Types/Mangopay';

function Index( props ) {
    const [listLoading, setListLoading] = useState<boolean>(true);
    const [allCards, setAllCards] = useState<Array<RegisteredCard>>([]);
    const [selectedCard, setSelectedCard] = useState('');

    const getCards = async () => {
        setListLoading( true );

        try {
            const fetchedData = await apiFetch({ path: '/dokan/v1/mangopay/block/registered/cards' });

            if ( 'object' === typeof fetchedData && Object.values( fetchedData ).length ) {
                let cards: RegisteredCard[] = Object.values( fetchedData );
                setAllCards( cards );

                // Set the last card as selected.
                onChangeSelectedCard(cards[cards.length-1].Id);
            } else {
                setAllCards( [] );
                onChangeSelectedCard('');
            }
        } catch (error) {
            console.error('Error fetching registered cards:', error);
        } finally {
            setListLoading(false);
        }
    }

    const deleteCard = id => {
        setListLoading( true );

        apiFetch({
            path: '/dokan/v1/mangopay/block/registered/cards',
            method: 'DELETE',
            data: {
                card_id: id
            }
        }).finally(()=> {
            getCards();
        });
    }

    const onChangeSelectedCard = card => {
        setSelectedCard(card);
        props.onChange(card)
    }

    useEffect(() => {
        getCards();
    }, []);

    return(
        <div className='mangopay-registered-cards'>
            {
                listLoading ?
                <CardListLoader/>
                :
                <CardList
                    deleteCard={(id)=>deleteCard(id)}
                    refreshCards={()=>getCards()}
                    cards={allCards}
                    selected={selectedCard}
                    setSelectedCard={onChangeSelectedCard}
                />
            }
        </div>
    );
}
export default Index;
